export let customSettings = {
  captchaOn: false,
  toastPosition: "top-right",
  toastClose: 5000,
};
